export const genderEnum = {
    '-1': '未知',
    0: '男',
    1: '女'
};

export const rules = {
    oldAuthCode: [
        {
            required: true,
            message: '请输入验证码',
            trigger: 'blur'
        }
    ],
    newAuthCode: [
        {
            required: true,
            message: '请输入验证码',
            trigger: 'blur'
        }
    ],
    phone: [
        {
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
        }
    ],
    newPhone: [
        {
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
        }
    ]
};
